import type { FileNode } from '@/types';

/**
 * Flatten the FileNode tree into a sorted list of file paths (directories
 * skipped). Used to give the LLM a project-shape overview without forcing
 * it to inspect every file's contents. Pre-fix the chat sent only the
 * active filename — the LLM had no idea what other files existed and
 * answered "I cannot see the files in the file nav".
 */
export function flattenFileTreePaths(node: FileNode | null): string[] {
  if (!node) return [];
  const paths: string[] = [];
  const walk = (n: FileNode) => {
    if (n.type === 'file') {
      paths.push(n.path);
    } else if (n.children) {
      for (const child of n.children) walk(child);
    }
  };
  walk(node);
  return paths.sort();
}
